import React, { Component } from 'react';
import { Table } from 'antd';
import TableText from "../../TableText";

class index extends Component {
    onChange = (name, value, i) => {

    }
    render() {
        const data = this.props.data;
        const columns = [{
            title: 'Departments',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            render: (text, record, index) => {
                const props = { text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex: [8] };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Target',
            dataIndex: 'risks',
            key: 'risks',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "risks", onChange: this.onChange, totalIndex: [8],
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Actual',
            dataIndex: 'file',
            key: 'file',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: 'number', name: "file", onChange: this.onChange, totalIndex: [8],
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: '%',
            dataIndex: 'control',
            key: 'control',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: "percent", name: "control", onChange: this.onChange, totalIndex: [8],
                };
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: '-',
            dataIndex: 'total',
            key: 'total',
            align: "center",
            render: (text, record, index) => {
                const props = {
                    text, index, type: "number", name: "total", onChange: this.onChange, totalIndex: [8], warn: true
                };
                return (
                    <TableText data={props} />
                )
            }
        }];
        return (
            <Table
                columns={columns}
                dataSource={data}
                size="middle"
                bordered
                pagination={false}
                loading={this.props.loading}
                className="content"
                rowKey={(record, index) => index}
            />
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-10/2-2.js